/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiProjectSettingKey;
(function (ApiProjectSettingKey) {
    ApiProjectSettingKey["SETTING_UNSPECIFIED"] = "SETTING_UNSPECIFIED";
    ApiProjectSettingKey["BLOCKED_IPS"] = "BLOCKED_IPS";
    ApiProjectSettingKey["ENGAGEMENT_SCORE"] = "ENGAGEMENT_SCORE";
    ApiProjectSettingKey["IGNORE_REFERRERS"] = "IGNORE_REFERRERS";
    ApiProjectSettingKey["LEAD_SCORE_MAX"] = "LEAD_SCORE_MAX";
    ApiProjectSettingKey["RETENTION_LIFETIME_MONTHS"] = "RETENTION_LIFETIME_MONTHS";
    ApiProjectSettingKey["RETENTION_MAX_CHANCE"] = "RETENTION_MAX_CHANCE";
    ApiProjectSettingKey["RETENTION_GRACE_PERIOD_MONTHS"] = "RETENTION_GRACE_PERIOD_MONTHS";
    ApiProjectSettingKey["PAGE_USE_QUERY_STRING"] = "PAGE_USE_QUERY_STRING";
    ApiProjectSettingKey["SHOW_AWARENESS_ACQUISTION_RETENTION_INSIGHTS"] = "SHOW_AWARENESS_ACQUISTION_RETENTION_INSIGHTS";
    ApiProjectSettingKey["PROJECT_TYPE"] = "PROJECT_TYPE";
    ApiProjectSettingKey["USE_DATALAYER_SALES"] = "USE_DATALAYER_SALES";
    ApiProjectSettingKey["FB_PIXEL"] = "FB_PIXEL";
    ApiProjectSettingKey["UI_STATE"] = "UI_STATE";
    ApiProjectSettingKey["USE_DATALAYER_PAGEVIEWS"] = "USE_DATALAYER_PAGEVIEWS";
    ApiProjectSettingKey["USE_DATALAYER_CART_EVENTS"] = "USE_DATALAYER_CART_EVENTS";
    ApiProjectSettingKey["USE_DATALAYER_CHECKOUT_EVENTS"] = "USE_DATALAYER_CHECKOUT_EVENTS";
    ApiProjectSettingKey["USE_ECWID_PIXEL"] = "USE_ECWID_PIXEL";
    ApiProjectSettingKey["GOOGLE_ENABLE_MATCH_TYPE"] = "GOOGLE_ENABLE_MATCH_TYPE";
    ApiProjectSettingKey["BING_ENABLE_MATCH_TYPE"] = "BING_ENABLE_MATCH_TYPE";
    ApiProjectSettingKey["DISABLE_CRAWLER"] = "DISABLE_CRAWLER";
    ApiProjectSettingKey["ENABLE_CRAWLER_PAGE_STATUS_CODE"] = "ENABLE_CRAWLER_PAGE_STATUS_CODE";
    ApiProjectSettingKey["DEFAULT_ATTRIBUTION_MODEL"] = "DEFAULT_ATTRIBUTION_MODEL";
    ApiProjectSettingKey["EBA_ATTRIBUTION_MODEL"] = "EBA_ATTRIBUTION_MODEL";
    ApiProjectSettingKey["ENABLE_GOOGLE_SYNC_UTM"] = "ENABLE_GOOGLE_SYNC_UTM";
    ApiProjectSettingKey["LANDING_THEME"] = "LANDING_THEME";
    ApiProjectSettingKey["USE_DATALAYER_ADDITIONAL_EVENTS"] = "USE_DATALAYER_ADDITIONAL_EVENTS";
    ApiProjectSettingKey["PUSH_EFFECTIVE_SESSIONS_TO_META"] = "PUSH_EFFECTIVE_SESSIONS_TO_META";
    ApiProjectSettingKey["PUSH_EFFECTIVE_PAGE_VIEWS_TO_META"] = "PUSH_EFFECTIVE_PAGE_VIEWS_TO_META";
    ApiProjectSettingKey["CONSENT_CAPTURE"] = "CONSENT_CAPTURE";
    ApiProjectSettingKey["CONSENT_ENFORCEMENT"] = "CONSENT_ENFORCEMENT";
    ApiProjectSettingKey["NO_CONSENT_BEHAVIOR"] = "NO_CONSENT_BEHAVIOR";
    ApiProjectSettingKey["PAGEVIEW_KEY_SIZE"] = "PAGEVIEW_KEY_SIZE";
    ApiProjectSettingKey["LEAD_KEY_SIZE"] = "LEAD_KEY_SIZE";
    ApiProjectSettingKey["WOOCOMMERCE_SCRIPT_BASE_URL"] = "WOOCOMMERCE_SCRIPT_BASE_URL";
    ApiProjectSettingKey["WOOCOMMERCE_SCRIPT_STRATEGY"] = "WOOCOMMERCE_SCRIPT_STRATEGY";
    ApiProjectSettingKey["WOOCOMMERCE_SCRIPT_POSITION"] = "WOOCOMMERCE_SCRIPT_POSITION";
    ApiProjectSettingKey["WOOCOMMERCE_SERVER_SIDE_TRACKING_ENABLED"] = "WOOCOMMERCE_SERVER_SIDE_TRACKING_ENABLED";
})(ApiProjectSettingKey || (ApiProjectSettingKey = {}));
export function ApiProjectSettingKeyFromJSON(json) {
    return ApiProjectSettingKeyFromJSONTyped(json, false);
}
export function ApiProjectSettingKeyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiProjectSettingKeyToJSON(value) {
    return value;
}
